class Valis {
  constructor () {
    this.instances = []
  }

  initComponents (components, collection, debug = false) {
    this.components = collection
    collection.forEach((el, i) => {
      const componentName = el.dataset.component
      const Component = components[componentName]
      // console.log(componentName)

      if (typeof Component === 'function') {
        const instance = new Component(el, i)

        if (debug) {
          console.debug('Component Element:', el, `Component Name: ${componentName}`)
        }

        this.instances.push({ instance, componentName, i })
        // All Components have an init method.
        instance.init()
        this.loadingProgress(i)
      }
    })
  }

  loadingProgress (index) {
    // console.log(index, this.components.length - 1)
    if (index === this.components.length - 1) {
      // console.log('Components/ready22222')
      document.body.dispatchEvent(new CustomEvent('Components/ready'))
    }
  }

  destroyComponents () {
    // Destroy all existing instances.
    this.instances.forEach(({ instance }) => {
      if (instance) {
        if (typeof instance.destroy === 'function') {
          // console.log(instance)
          instance.destroy()
        }
      }
    })

    // Reset instance array for the next page.
    // console.log(this.instances)
    this.instances = []
    // console.log('Components/destroyed')

    document.body.dispatchEvent(new CustomEvent('Components/destroyed'))
  }
}

export default Valis



//////////////////
// WEBPACK FOOTER
// ./scripts/util/Valis.js
// module id = 11
// module chunks = 0